import { Spin } from 'antd';
import React from 'react';
import { Select, Button } from '..';
import Wrapper from './style';

const Index = (props) => {
  const {
    placeholder,
    filterOptions = [],
    minWidth,
    onSearch,
    loading,
  } = props;

  return ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    return (
      <Wrapper minWidth={minWidth} className="component_tableFilter_select">
        <Select
          notFoundContent={loading ? <Spin size="small" /> : null}
          loading={loading}
          showSearch={onSearch}
          onSearch={onSearch}
          placeholder={placeholder || 'placeholder'}
          value={selectedKeys}
          onSelect={(value) => {
            return setSelectedKeys(value ? [value] : [null]);
          }}
        >
          {filterOptions.map((item) => {
            return (
              <Select.Option key={item?.id} value={item?.id}>
                {item?.text}
              </Select.Option>
            );
          })}
          {filterOptions.length === 0 && (
            <Select.Option disabled>Not Found</Select.Option>
          )}
        </Select>
        <div className="buttons-wrapper">
          <Button
            onClick={() => {
              clearFilters();
            }}
            type="secondary"
          >
            Reset
          </Button>
          <Button
            type="primary"
            onClick={() => {
              confirm();
            }}
          >
            Filter
          </Button>
        </div>
      </Wrapper>
    );
  };
};

export default Index;
